/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, FlagOutlined, MoneyOutlined} from "@mui/icons-material";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {TIPOMOVIMIENTO} from "../../../Constantes";

const Formulario_Movimiento = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoFecha Icono={AccountCircleOutlined} nombre={'Fecha'} dato={'fecha'} {...props}
                                  requerido={'La fecha es requerido'} editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>

                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Tipo'} dato={'tipo'} {...props}
                                   requerido={'El tipo es requerido'} opciones={TIPOMOVIMIENTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'valor'} dato={'valor'} {...props}
                                   requerido={'El Valor es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={3} nombre={'Descripcion'} dato={'descripcion'} {...props}
                                  requerido={'La descripcion es requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Movimiento